(function () {
  const drawer = document.querySelector("[data-supercat-cart-drawer]");
  if (!drawer) return;

  const panel = drawer.querySelector(".sc-cart-drawer__panel");
  const itemsNode = drawer.querySelector("[data-sc-cart-items]");
  const emptyNode = drawer.querySelector("[data-sc-cart-empty]");
  const footerNode = drawer.querySelector("[data-sc-cart-footer]");
  const subtotalNode = drawer.querySelector("[data-sc-cart-subtotal]");
  const savingsNode = drawer.querySelector("[data-sc-cart-savings]");
  const totalNode = drawer.querySelector("[data-sc-cart-total]");
  const shippingNode = drawer.querySelector("[data-sc-cart-shipping]");
  const fallbackImage = drawer.dataset.fallbackImage || "";
  const subscriptionProductHandle = drawer.dataset.subscriptionProductHandle || "supercat-hydration-flow-daily";
  const oneBoxVariantId = Number(drawer.dataset.oneBoxVariant);
  const twoBoxVariantId = Number(drawer.dataset.twoBoxVariant);
  const twoBoxPlanId = Number(drawer.dataset.twoBoxPlan);
  const twoBoxPrice = Number(drawer.dataset.twoBoxPrice);
  const twoBoxCompare = Number(drawer.dataset.twoBoxCompare);
  const giftItems = [
    {
      id: Number(drawer.dataset.spoonGiftVariant),
      image: drawer.dataset.spoonGiftImage || "",
      label: "HydraFlow Feeding Spoon",
    },
    {
      id: Number(drawer.dataset.planGiftVariant),
      image: drawer.dataset.planGiftImage || "",
      label: "Personalized Cat Hydration Plan",
    },
  ].filter((gift) => gift.id > 0);
  const giftByVariantId = new Map(giftItems.map((gift) => [gift.id, gift]));
  const moneyFormat = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
  const sellableCountries = new Set(["US", "CA"]);
  const productJsonCache = new Map();
  let closeTimer = null;
  let lastOfferContext = null;

  const formatPrice = (cents) => moneyFormat.format((Number(cents) || 0) / 100);
  const formatMoney = (cents) => `${formatPrice(cents)} USD`;
  const text = (value) => String(value || "").replace(/\s+/g, " ").trim();
  const publishCartEvent = (eventName, detail) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...detail });
    document.dispatchEvent(new CustomEvent(eventName, { detail }));
  };
  const cookieValue = (name) => document.cookie
    .split("; ")
    .find((cookie) => cookie.startsWith(`${name}=`))
    ?.split("=")
    .slice(1)
    .join("=") || "";

  const currentCountry = () => {
    const localization = decodeURIComponent(cookieValue("localization")).toUpperCase();
    if (localization) return localization;
    return String(window.Shopify?.country || "").toUpperCase();
  };

  const ensureSellableMarket = async (force = false) => {
    const country = currentCountry();
    if (!force && sellableCountries.has(country)) return;

    const body = new URLSearchParams();
    body.set("form_type", "localization");
    body.set("utf8", "✓");
    body.set("_method", "put");
    body.set("country_code", "US");
    body.set("return_to", `${window.location.pathname}${window.location.search}`);

    await fetch("/localization", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "text/html, application/xhtml+xml",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: body.toString(),
    }).catch(() => {});

    document.cookie = "localization=US; path=/; max-age=31536000; SameSite=Lax";
    document.cookie = "cart_currency=USD; path=/; max-age=1209600; SameSite=Lax";
  };

  const tomorrowLabel = () => 'Ships <strong>tomorrow</strong>';

  const updateShipping = () => {
    if (shippingNode) shippingNode.innerHTML = tomorrowLabel();
  };

  const openDrawer = () => {
    window.clearTimeout(closeTimer);
    drawer.hidden = false;
    document.body.classList.add("sc-cart-drawer-open");
    requestAnimationFrame(() => {
      drawer.classList.add("is-open");
      panel?.focus({ preventScroll: true });
    });
  };

  const closeDrawer = () => {
    drawer.classList.remove("is-open");
    document.body.classList.remove("sc-cart-drawer-open");
    closeTimer = window.setTimeout(() => {
      drawer.hidden = true;
    }, 280);
  };

  const fetchCart = async () => {
    const response = await fetch(`/cart.js?ts=${Date.now()}`, {
      cache: "no-store",
      headers: { Accept: "application/json" },
    });
    if (!response.ok) throw new Error("Unable to load cart.");
    return response.json();
  };

  const changeLine = async (key, quantity) => {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!response.ok) throw new Error("Unable to update cart.");
    return response.json();
  };

  const addItems = async (items) => {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      cache: "no-store",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    });
    if (!response.ok) throw new Error(await parseCartError(response));
    return response.json();
  };

  const updateLines = async (updates) => {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      cache: "no-store",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
    });
    if (!response.ok) throw new Error("Unable to update your welcome gifts.");
    return response.json();
  };

  const isGiftItem = (item) => giftByVariantId.has(Number(item.variant_id));
  const isSecondBoxBumpPage = () => Boolean(document.querySelector('[data-sc-cart-bump-variant="bump"]'));
  const oneBoxSubscriptionLine = (cart) => cart.items.find((item) => (
    !isGiftItem(item)
    && Number(item.variant_id) === oneBoxVariantId
    && item.quantity === 1
    && Boolean(item.selling_plan_allocation)
  ));
  const hasTwoBoxLine = (cart) => cart.items.some((item) => !isGiftItem(item) && Number(item.variant_id) === twoBoxVariantId);
  const hasQualifyingSubscription = (cart) => cart.items.some((item) => (
    !isGiftItem(item)
    && (item.handle === subscriptionProductHandle || item.handle === "supercat-hydration-flow-daily-1")
    && Boolean(item.selling_plan_allocation)
  ));

  const giftLineProperties = () => ({
    _sc_welcome_gift: "Included with first subscription order",
    _sc_gift_lock: "true",
  });

  const giftAddItems = (cart) => {
    const presentVariantIds = new Set(cart.items.map((item) => Number(item.variant_id)));
    return giftItems
      .filter((gift) => !presentVariantIds.has(gift.id))
      .map((gift) => ({ id: gift.id, quantity: 1, properties: giftLineProperties() }));
  };

  const syncWelcomeGifts = async (cart) => {
    if (!giftItems.length) return cart;

    const giftLines = cart.items.filter(isGiftItem);
    if (!hasQualifyingSubscription(cart)) {
      if (!giftLines.length) return cart;
      const removals = Object.fromEntries(giftLines.map((item) => [item.key, 0]));
      return updateLines(removals);
    }

    const quantityCorrections = Object.fromEntries(
      giftLines.filter((item) => item.quantity !== 1).map((item) => [item.key, 1]),
    );
    if (Object.keys(quantityCorrections).length) cart = await updateLines(quantityCorrections);

    const missingGifts = giftAddItems(cart);
    if (missingGifts.length) {
      await addItems(missingGifts);
      cart = await fetchCart();
    }

    return cart;
  };

  const imageMarkup = (item) => {
    const image = giftByVariantId.get(Number(item.variant_id))?.image || item.image || fallbackImage;
    if (image) {
      return `<img class="sc-cart-item__image" src="${image}" alt="${escapeHtml(item.product_title || "SuperCat product")}" loading="lazy">`;
    }
    return '<div class="sc-cart-item__image-fallback">SuperCat</div>';
  };

  const escapeHtml = (value) => text(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");

  const propertyValue = (item, key) => {
    const properties = item.properties || {};
    if (Array.isArray(properties)) {
      const property = properties.find((entry) => entry && (entry.name === key || entry[0] === key));
      return property?.value ?? property?.[1] ?? "";
    }
    return properties[key] || "";
  };

  const normalizedProperties = (item) => {
    const properties = item?.properties || {};
    if (Array.isArray(properties)) {
      return Object.fromEntries(properties
        .filter(Boolean)
        .map((entry) => [entry.name ?? entry[0], entry.value ?? entry[1]])
        .filter(([key, value]) => key && value));
    }
    return Object.fromEntries(Object.entries(properties).filter(([, value]) => value));
  };

  const restorePayloadForLine = (item) => {
    if (!item) return null;
    const payload = {
      id: Number(item.variant_id),
      quantity: Number(item.quantity) || 1,
    };
    const sellingPlan = Number(item.selling_plan_allocation?.selling_plan?.id);
    const properties = normalizedProperties(item);
    if (sellingPlan) payload.selling_plan = sellingPlan;
    if (Object.keys(properties).length) payload.properties = properties;
    return payload;
  };

  const preyOfferCaption = (item) => {
    if (item.handle !== "supercat-hydration-flow-daily-1") return "";
    const boxes = {50375450132618: 3, 50375450165386: 2}[Number(item.variant_id)] || 1;
    const discount = {50375433683082: 5, 50375433715850: 10}[Number(item.variant_id)];
    return `<p>${formatPrice(Math.round(item.final_price / boxes))} each${discount && item.selling_plan_allocation ? ` · Extra ${discount}% multi-cat savings included` : ""}</p>`;
  };
  // One-time bundles of the HydraFlow offer page: show one row per box (visual only; the cart line is unchanged).
  const ONE_BOX_PRICE = 4995;
  const bundleRows = (item) => {
    if (item.handle !== "supercat-hydration-flow-daily-1" || item.selling_plan_allocation) return null;
    const variantId = Number(item.variant_id);
    const total = Number(item.final_price);
    if (variantId === 50375450165386) {
      return [
        { label: "Box 1", price: ONE_BOX_PRICE },
        { label: "Box 2 · 50% off", compare: ONE_BOX_PRICE, price: total - ONE_BOX_PRICE },
      ];
    }
    if (variantId === 50375450132618) {
      return [
        { label: "Box 1", price: ONE_BOX_PRICE },
        { label: "Box 2", price: ONE_BOX_PRICE },
        { label: "Box 3 · Free", compare: ONE_BOX_PRICE, free: true },
      ];
    }
    return null;
  };
  const bundleRowsMarkup = (item) => {
    const rows = bundleRows(item);
    if (!rows) return "";
    const deal = Number(item.variant_id) === 50375450132618 ? "Buy 2, Get 1 FREE" : "Buy 1, Get 1 at 50% OFF";
    const bundles = Math.max(1, Number(item.quantity) || 1);
    const saved = bundles * rows.reduce((sum, row) => sum + (row.compare ? row.compare - (row.free ? 0 : row.price) : 0), 0);
    const thumb = item.image ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy">` : "";
    const rowMarkup = (row, index) => {
      const kind = row.free ? "is-free" : row.compare ? "is-deal" : "";
      const tag = row.free ? `<em class="sc-cart-bundle__tag">FREE</em>` : row.compare ? `<em class="sc-cart-bundle__tag">50% OFF</em>` : "";
      const price = row.free ? `<b>$0.00</b>` : `<b>${formatPrice(row.price)}</b>`;
      return `<li class="${kind}"><span class="sc-cart-bundle__thumb">${thumb}<i>${index + 1}</i></span><span class="sc-cart-bundle__name">Box ${index + 1}${tag}<small>30 sachets</small></span><span class="sc-cart-bundle__price">${row.compare ? `<s>${formatPrice(row.compare)}</s>` : ""}${price}</span></li>`;
    };
    return `<div class="sc-cart-bundle"><p class="sc-cart-bundle__deal">${escapeHtml(deal)}${bundles > 1 ? ` × ${bundles}` : ""}</p><ul>${rows.map(rowMarkup).join("")}</ul><p class="sc-cart-bundle__save"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 10.5l3.2 3.2L15 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>You save an extra ${formatPrice(saved)} with this deal</p></div>`;
  };
  const compareAtUnit = (item) => {
    const fromProperty = Number(propertyValue(item, "_sc_compare_at_unit"));
    if (fromProperty > 0) return fromProperty;
    return Math.max(Number(item.original_price) || 0, Number(item.final_price) || 0);
  };

  const itemDelivery = (item) => {
    const delivery = propertyValue(item, "_sc_delivery");
    if (delivery) return delivery;
    return item.selling_plan_allocation ? "Delivered on subscription" : "One-time purchase";
  };

  const contextForItem = (item, index) => {
    if (!isGiftItem(item) && index === 0 && lastOfferContext && !propertyValue(item, "_sc_boxes") && !propertyValue(item, "_sc_delivery")) return lastOfferContext;
    const boxes = propertyValue(item, "_sc_boxes");
    const variantTitle = boxes || (item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : `${item.quantity} Box`);
    return {
      amount: `Amount: ${variantTitle}`,
      delivery: itemDelivery(item),
    };
  };

  const renderError = (message) => {
    itemsNode.innerHTML = `<p class="sc-cart-drawer__error">${escapeHtml(message)}</p>`;
    emptyNode.hidden = true;
    footerNode.hidden = true;
    openDrawer();
  };

  const secondBoxBumpMarkup = (line) => {
    if (!line || !twoBoxVariantId || !twoBoxPlanId || !twoBoxPrice) return "";
    const upgradeDifference = Math.max(0, twoBoxPrice - Number(line.final_price || 0));
    const image = line.image || fallbackImage;
    return `
      <aside
        class="sc-cart-bump"
        data-sc-cart-bump
        data-cart-key="${escapeHtml(line.key)}"
        data-box-default-test="${escapeHtml(propertyValue(line, "_sc_box_default_test"))}"
        data-cart-bump-test="${escapeHtml(propertyValue(line, "_sc_cart_bump_test"))}"
      >
        ${image ? `<img class="sc-cart-bump__image" src="${escapeHtml(image)}" alt="Two-box HydraFlow Daily supply" loading="lazy">` : ""}
        <div class="sc-cart-bump__copy">
          <span>ONE-TAP UPGRADE</span>
          <strong>Make it a 60-day supply</strong>
          <p>Add a second box for ${formatPrice(upgradeDifference)} more today.</p>
          <p><strong>${formatPrice(twoBoxPrice)} today, then every 60 days.</strong> Shipping and tax calculated at checkout. Pause, skip, or cancel anytime.</p>
        </div>
        <button type="button" data-sc-cart-bump-upgrade>Upgrade to 2 Boxes — ${formatPrice(twoBoxPrice)} today</button>
        <button type="button" data-sc-cart-bump-dismiss>Not now — keep 1 Box</button>
      </aside>
    `;
  };

  const renderCart = (cart) => {
    updateShipping();
    const hasItems = cart.items && cart.items.length > 0;
    emptyNode.hidden = hasItems;
    footerNode.hidden = !hasItems;
    itemsNode.hidden = !hasItems;

    if (!hasItems) {
      itemsNode.innerHTML = "";
      openDrawer();
      return;
    }

    let paidItemIndex = -1;
    itemsNode.innerHTML = cart.items.map((item) => {
      const isGift = isGiftItem(item);
      if (!isGift) paidItemIndex += 1;
      if (isGift) {
        const gift = giftByVariantId.get(Number(item.variant_id));
        return `
          <article class="sc-cart-item sc-cart-item--gift" data-cart-key="${escapeHtml(item.key)}">
            ${imageMarkup(item)}
            <div class="sc-cart-item__body">
              <span class="sc-cart-item__gift-badge">FREE WELCOME GIFT</span>
              <h3 class="sc-cart-item__title">${escapeHtml(gift?.label || item.product_title || item.title)}</h3>
              <p class="sc-cart-item__gift-note">Included with your subscription</p>
            </div>
            <strong class="sc-cart-item__line-price sc-cart-item__line-price--free">$0.00</strong>
          </article>
        `;
      }

      const index = paidItemIndex;
      const context = contextForItem(item, index);
      return `
        <article class="sc-cart-item" data-cart-key="${escapeHtml(item.key)}">
          ${imageMarkup(item)}
          <div class="sc-cart-item__body">
            <h3 class="sc-cart-item__title">${escapeHtml(item.product_title || item.title)}</h3>
            ${bundleRows(item) ? bundleRowsMarkup(item) : `<p class="sc-cart-item__price">${formatPrice(item.final_price)}${compareAtUnit(item) > item.final_price ? ` <s>${formatPrice(compareAtUnit(item))}</s>` : ""}</p>${preyOfferCaption(item)}`}
            <p class="sc-cart-item__meta">${escapeHtml(context.amount)}</p>
            <p class="sc-cart-item__meta">${escapeHtml(context.delivery)}</p>
            <div class="sc-cart-item__controls">
              <div class="sc-cart-qty" aria-label="Quantity selector">
                <button type="button" data-sc-cart-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-sc-cart-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
              </div>
              <button class="sc-cart-item__remove" type="button" data-sc-cart-remove aria-label="Remove ${escapeHtml(item.product_title || item.title)}"><span aria-hidden="true"></span></button>
            </div>
          </div>
          <strong class="sc-cart-item__line-price">${formatPrice(item.final_line_price)}</strong>
        </article>
      `;
    }).join("");

    const bumpLine = isSecondBoxBumpPage() && !hasTwoBoxLine(cart) ? oneBoxSubscriptionLine(cart) : null;
    if (bumpLine && drawer.dataset.bumpDismissedKey !== bumpLine.key) {
      itemsNode.insertAdjacentHTML("beforeend", secondBoxBumpMarkup(bumpLine));
      if (drawer.dataset.bumpImpressionKey !== bumpLine.key) {
        drawer.dataset.bumpImpressionKey = bumpLine.key;
        publishCartEvent("supercat_cart_bump_view", {
          experiment: "second-box-v1",
          source_variant: oneBoxVariantId,
          target_variant: twoBoxVariantId,
          target_price: twoBoxPrice / 100,
          page_path: window.location.pathname,
        });
      }
    }

    const compareSubtotal = cart.items.reduce((sum, item) => sum + compareAtUnit(item) * item.quantity, 0);
    const cartLevelDiscount = (cart.cart_level_discount_applications || []).reduce((sum, app) => sum + (Number(app.total_allocated_amount) || 0), 0);
    const lineTotal = cart.items.reduce((sum, item) => sum + (Number(item.final_line_price) || 0), 0);
    const displayTotal = cart.items.length ? Math.max(0, lineTotal - cartLevelDiscount) : 0;
    const subtotal = compareSubtotal || cart.items_subtotal_price || cart.original_total_price || displayTotal;
    const savings = Math.max(0, subtotal - displayTotal);
    subtotalNode.textContent = formatMoney(subtotal);
    savingsNode.textContent = formatMoney(savings);
    totalNode.textContent = formatMoney(displayTotal);
    openDrawer();
  };

  const selectedText = (root, selector) => {
    const selected = root?.querySelector(selector);
    return text(selected?.innerText || selected?.textContent);
  };

  const conciseAmount = (rawAmount) => {
    const normalized = text(rawAmount);
    const packageMatch = normalized.match(/\b([123])\s+Boxes?\b/i);
    if (packageMatch) return `${packageMatch[1]} ${Number(packageMatch[1]) === 1 ? "Box" : "Boxes"}`;
    const bottleMatch = normalized.match(/\b([0-9]+)\s+Bottles?\b/i);
    if (bottleMatch) return `${bottleMatch[1]} ${Number(bottleMatch[1]) === 1 ? "Bottle" : "Bottles"}`;
    const sachetMatch = normalized.match(/\b([0-9]+)\s+sachets?\b/i);
    if (sachetMatch) return `${sachetMatch[1]} sachets`;
    return normalized.split(/\n|Free shipping|\+ \$4\.95 shipping|—|\$/)[0] || normalized;
  };

  const collectOfferContext = (form) => {
    const root = form.closest(".pg-choose-box, .shopify-product-box, .offer-panel, section") || document;
    const selectedPackage = selectedText(root, ".pg-package-card.is-selected, .pg-package-card:has(input:checked), .package-card.selected, .package-card:has(input:checked)");
    const selectedVariant = selectedText(form, ".package-card.selected, .package-card:has(input:checked)");
    const rawAmount = selectedPackage || selectedVariant;
    const packageTitle = conciseAmount(rawAmount);
    const selectedCard = form.querySelector(".offer-card.selected, .offer-card input:checked")?.closest(".offer-card");
    return {
      amount: packageTitle ? `Amount: ${packageTitle}` : `Amount: ${selectedCard?.dataset.boxLabel || "1 Box"}`,
      delivery: selectedCard?.dataset.delivery && selectedPurchaseType(form) === "subscription" ? selectedCard.dataset.delivery : "One-time purchase",
    };
  };

  const selectedOfferCard = (form) => (form.querySelector('.offer-card input[name="id"]:checked') || form.querySelector(".offer-card.selected, .offer-card input:checked"))?.closest(".offer-card");
  const selectedPurchaseType = (form) => form.querySelector('input[name="purchase_option"]:checked')?.value || "one-time";

  const productHandleForForm = (form) => form.closest("[data-product-handle]")?.dataset.productHandle || "";

  const fetchProductJson = async (handle) => {
    if (!handle) throw new Error("Subscriptions are temporarily unavailable. Please try again.");
    if (!productJsonCache.has(handle)) {
      productJsonCache.set(handle, fetch(`/products/${encodeURIComponent(handle)}.js?subscription_plan_lookup=${Date.now()}`, {
        cache: "no-store",
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      }).then((response) => {
        if (!response.ok) throw new Error("Unable to load current subscription options.");
        return response.json();
      }).catch((error) => {
        productJsonCache.delete(handle);
        throw error;
      }));
    }
    return productJsonCache.get(handle);
  };

  const deliveryMonthsForCard = (card) => {
    const boxes = Number(card?.dataset.boxes);
    if (boxes > 0) return boxes;
    const delivery = `${card?.dataset.delivery || ""} ${card?.dataset.boxLabel || ""}`;
    const monthMatch = delivery.match(/every\s+(\d+)\s+months?/i);
    if (monthMatch) return Number(monthMatch[1]);
    const dayMatch = delivery.match(/every\s+(\d+)\s+days?/i);
    if (dayMatch) return Math.max(1, Math.round(Number(dayMatch[1]) / 30));
    return 1;
  };

  const planMatchesMonths = (plan, months) => {
    const optionText = Array.isArray(plan?.options)
      ? plan.options.map((option) => option?.value || option).join(" ")
      : "";
    const planText = text(`${plan?.name || ""} ${plan?.description || ""} ${optionText}`).toLowerCase();
    if (months === 1) {
      return /every\s+(?:1\s+)?month\b/.test(planText) || /\b30\s*days?\b/.test(planText);
    }
    return planText.includes(`every ${months} months`) || planText.includes(`${months * 30} days`);
  };

  // Page-only plans (e.g. the hybrid-stat $29.95 monthly plan) are never auto-picked; only a page that sends the id itself gets them.
  const pageOnlyPlanIds = new Set([3153723530]);

  const liveSellingPlanForVariant = (product, variantId, months) => {
    const variant = product?.variants?.find((item) => Number(item.id) === Number(variantId));
    const allocations = variant?.selling_plan_allocations || [];
    const applicableIds = new Set(allocations.map((allocation) => Number(allocation.selling_plan_id)));
    const allGroups = product?.selling_plan_groups || [];
    const appstleGroups = allGroups.filter((group) => group.app_id === "appstle");
    const liveGroups = appstleGroups.length ? appstleGroups : allGroups;
    const liveIds = new Set(liveGroups.flatMap((group) => group.selling_plans || []).map((plan) => Number(plan.id)));
    const plans = liveGroups.flatMap((group) => group.selling_plans || []).filter((plan) => !pageOnlyPlanIds.has(Number(plan.id)));
    allocations.forEach((allocation) => { if (pageOnlyPlanIds.has(Number(allocation.selling_plan_id))) applicableIds.delete(Number(allocation.selling_plan_id)); });
    const matchingPlan = plans.find((plan) => applicableIds.has(Number(plan.id)) && planMatchesMonths(plan, months));
    if (matchingPlan) return String(matchingPlan.id);

    const regularAllocations = allocations.filter((allocation) => liveIds.has(Number(allocation.selling_plan_id)) && !pageOnlyPlanIds.has(Number(allocation.selling_plan_id)));
    const fallbackAllocation = regularAllocations[Math.max(0, Math.min(regularAllocations.length - 1, months - 1))];
    return fallbackAllocation?.selling_plan_id ? String(fallbackAllocation.selling_plan_id) : "";
  };

  const syncLiveSellingPlan = async (form, formData) => {
    if (selectedPurchaseType(form) !== "subscription") return formData;
    if (pageOnlyPlanIds.has(Number(formData.get("selling_plan")))) return formData;

    const selectedCard = selectedOfferCard(form);
    const variantId = formData.get("id");
    const product = await fetchProductJson(productHandleForForm(form));
    const sellingPlan = liveSellingPlanForVariant(product, variantId, deliveryMonthsForCard(selectedCard));

    if (!sellingPlan) {
      throw new Error("Subscriptions are temporarily unavailable for this package. Please try again shortly.");
    }

    formData.set("selling_plan", sellingPlan);
    if (selectedCard) selectedCard.dataset.sellingPlanId = sellingPlan;
    const sellingPlanInput = form.querySelector("[data-sc-selling-plan]");
    if (sellingPlanInput) sellingPlanInput.value = sellingPlan;
    return formData;
  };

  const normalizeCartFormData = (form, formData) => {
    const selectedCard = selectedOfferCard(form);
    const checkedId = selectedCard?.querySelector('input[name="id"]') || form.querySelector('input[name="id"]:checked, input[name="id"]');
    const isSubscription = selectedPurchaseType(form) === "subscription";
    const formPlan = formData.get("selling_plan");
    const sellingPlan = selectedCard?.dataset.sellingPlanId || form.querySelector("[data-sc-selling-plan]")?.value
      || (pageOnlyPlanIds.has(Number(formPlan)) ? formPlan : "") || "";

    if (checkedId?.value) formData.set("id", checkedId.value);
    if (!formData.get("quantity")) formData.set("quantity", "1");
    formData.delete("purchase_option");

    if (isSubscription && sellingPlan) {
      formData.set("selling_plan", sellingPlan);
    } else {
      formData.delete("selling_plan");
    }

    return formData;
  };

  const cartPayloadFromFormData = (formData, existingCart, includeGifts) => {
    const properties = {};
    formData.forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && value) properties[match[1]] = value;
    });

    const item = {
      id: Number(formData.get("id")),
      quantity: Number(formData.get("quantity")) || 1,
    };

    const sellingPlan = formData.get("selling_plan");
    if (sellingPlan) item.selling_plan = Number(sellingPlan);
    if (Object.keys(properties).length) item.properties = properties;

    const items = [item];
    if (includeGifts) items.push(...giftAddItems(existingCart));
    return { items };
  };

  const parseCartError = async (response) => {
    let message = "We couldn't add that item to your cart. Please try again.";
    try {
      const payload = await response.json();
      message = payload.description || payload.message || message;
    } catch (error) {}
    return message;
  };

  const postCartAdd = (formData, existingCart, includeGifts) => fetch("/cart/add.js", {
    method: "POST",
    cache: "no-store",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(cartPayloadFromFormData(formData, existingCart, includeGifts)),
  });

  const fetchVerifiedCart = async (formData) => {
    const cart = await syncWelcomeGifts(await fetchCart());
    const sellingPlan = Number(formData.get("selling_plan"));
    if (!sellingPlan) return cart;

    const variantId = Number(formData.get("id"));
    const hasSubscriptionLine = cart.items.some((item) => (
      Number(item.variant_id) === variantId
      && Number(item.selling_plan_allocation?.selling_plan?.id) === sellingPlan
    ));

    if (!hasSubscriptionLine) {
      throw new Error("The subscription could not be verified in your cart. Your order was not changed to a one-time purchase.");
    }

    const missingGift = giftItems.some((gift) => !cart.items.some((item) => Number(item.variant_id) === gift.id));
    if (missingGift) {
      throw new Error("Your subscription was added, but we couldn't verify both welcome gifts. Please try again.");
    }

    return cart;
  };

  const addFormToCart = async (form) => {
    await ensureSellableMarket();

    const formData = normalizeCartFormData(form, new FormData(form));
    await syncLiveSellingPlan(form, formData);
    lastOfferContext = collectOfferContext(form);
    const existingCart = await syncWelcomeGifts(await fetchCart());
    const includeGifts = selectedPurchaseType(form) === "subscription";

    let response = await postCartAdd(formData, existingCart, includeGifts);

    if (!response.ok) {
      let message = await parseCartError(response);
      const canRetryMarket = /sold out|unavailable|cannot be purchased/i.test(message) && !sellableCountries.has(currentCountry());
      if (canRetryMarket) {
        await ensureSellableMarket(true);
        response = await postCartAdd(formData, existingCart, includeGifts);
        if (response.ok) return fetchVerifiedCart(formData);
        message = await parseCartError(response);
      }

      throw new Error(message);
    }

    return fetchVerifiedCart(formData);
  };

  const handleCartSubmit = async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form || form.dataset.scCartNative === "true") return;
    event.preventDefault();
    event.stopImmediatePropagation();

    const submitter = event.submitter || form.querySelector('[type="submit"]');
    if (submitter) {
      submitter.disabled = true;
      submitter.dataset.originalText = submitter.textContent;
      submitter.textContent = "Adding...";
    }

    try {
      const cart = await addFormToCart(form);
      renderCart(cart);
    } catch (error) {
      renderError(error.message);
    } finally {
      if (submitter) {
        submitter.disabled = false;
        submitter.textContent = submitter.dataset.originalText || "Add to Cart";
      }
    }
  };

  document.addEventListener("submit", handleCartSubmit, true);

  // Shared entry point for offer buttons that add items without a form submit.
  window.SuperCatCart = Object.assign(window.SuperCatCart || {}, {
    open: async () => {
      lastOfferContext = null;
      renderCart(await syncWelcomeGifts(await fetchCart()));
    },
  });

  drawer.addEventListener("click", async (event) => {
    if (event.target.closest("[data-sc-cart-close]")) {
      closeDrawer();
      return;
    }

    const bumpDismiss = event.target.closest("[data-sc-cart-bump-dismiss]");
    if (bumpDismiss) {
      event.preventDefault();
      const bump = bumpDismiss.closest("[data-sc-cart-bump]");
      drawer.dataset.bumpDismissedKey = bump?.dataset.cartKey || "dismissed";
      publishCartEvent("supercat_cart_bump_decline", {
        experiment: "second-box-v1",
        source_variant: oneBoxVariantId,
        target_variant: twoBoxVariantId,
        page_path: window.location.pathname,
      });
      bump?.remove();
      return;
    }

    const bumpButton = event.target.closest("[data-sc-cart-bump-upgrade]");
    if (bumpButton) {
      event.preventDefault();
      const bump = bumpButton.closest("[data-sc-cart-bump]");
      const originalKey = bump?.dataset.cartKey || "";
      const originalLabel = bumpButton.textContent;
      let originalLine = null;
      let originalPayload = null;
      bumpButton.disabled = true;
      bumpButton.textContent = "Upgrading...";
      publishCartEvent("supercat_cart_bump_click", {
        experiment: "second-box-v1",
        source_variant: oneBoxVariantId,
        target_variant: twoBoxVariantId,
        page_path: window.location.pathname,
      });

      let addedKey = "";
      try {
        const beforeCart = await fetchCart();
        originalLine = beforeCart.items.find((item) => item.key === originalKey);
        if (!originalLine || Number(originalLine.variant_id) !== oneBoxVariantId || !originalLine.selling_plan_allocation) {
          throw new Error("This upgrade is no longer available for the current cart.");
        }
        originalPayload = restorePayloadForLine(originalLine);
        const added = await addItems([{
          id: twoBoxVariantId,
          quantity: 1,
          selling_plan: twoBoxPlanId,
          properties: {
            _sc_purchase_type: "Subscribe & Save",
            _sc_boxes: "2 Boxes",
            _sc_delivery: "Delivered every 2 months",
            _sc_compare_at_unit: String(twoBoxCompare || twoBoxPrice),
            _sc_savings_rate: "52",
            _sc_box_default_test: bump?.dataset.boxDefaultTest || "",
            _sc_cart_bump_test: bump?.dataset.cartBumpTest || "second-box-v1:bump",
            _sc_cart_bump_upgrade: "second-box-v1",
          },
        }]);
        addedKey = added?.items?.[0]?.key || added?.key || "";
        const afterAdd = await fetchCart();
        const verifiedAddedLine = afterAdd.items.find((item) => (
          (addedKey && item.key === addedKey)
          || (
            Number(item.variant_id) === twoBoxVariantId
            && Number(item.selling_plan_allocation?.selling_plan?.id) === twoBoxPlanId
          )
        ));
        if (!verifiedAddedLine) throw new Error("The 60-day subscription could not be verified. Your original selection is unchanged.");
        addedKey = verifiedAddedLine.key;
        await changeLine(originalKey, 0);
        const afterReplace = await fetchCart();
        const originalStillPresent = afterReplace.items.some((item) => item.key === originalKey);
        const targetPresent = afterReplace.items.some((item) => (
          item.key === addedKey
          && Number(item.variant_id) === twoBoxVariantId
          && Number(item.selling_plan_allocation?.selling_plan?.id) === twoBoxPlanId
        ));
        if (originalStillPresent || !targetPresent) throw new Error("We couldn't safely replace the original subscription.");
        const cart = await syncWelcomeGifts(afterReplace);
        lastOfferContext = { amount: "Amount: 2 Boxes", delivery: "Delivered every 2 months" };
        publishCartEvent("supercat_cart_bump_success", {
          experiment: "second-box-v1",
          target_variant: twoBoxVariantId,
          target_price: twoBoxPrice / 100,
          page_path: window.location.pathname,
        });
        renderCart(cart);
      } catch (error) {
        let recoveredCart = null;
        try {
          let currentCart = await fetchCart();
          let originalPresent = currentCart.items.some((item) => item.key === originalKey)
            || currentCart.items.some((item) => Number(item.variant_id) === oneBoxVariantId && item.selling_plan_allocation);
          if (!originalPresent && originalPayload) {
            await addItems([originalPayload]);
            originalPresent = true;
          }
          if (originalPresent && addedKey && currentCart.items.some((item) => item.key === addedKey)) {
            await changeLine(addedKey, 0);
          }
          recoveredCart = await syncWelcomeGifts(await fetchCart());
        } catch (rollbackError) {}
        publishCartEvent("supercat_cart_bump_error", {
          experiment: "second-box-v1",
          message: error.message,
          original_restored: Boolean(recoveredCart),
          page_path: window.location.pathname,
        });
        if (recoveredCart) {
          renderCart(recoveredCart);
          itemsNode.insertAdjacentHTML("afterbegin", `<p class="sc-cart-drawer__error">${escapeHtml(error.message)} Your original 1-box subscription remains in the cart.</p>`);
        } else {
          renderError(`${error.message} Please review your cart before checkout.`);
        }
      } finally {
        bumpButton.disabled = false;
        bumpButton.textContent = originalLabel;
      }
      return;
    }

    const line = event.target.closest(".sc-cart-item");
    if (!line) return;
    const key = line.dataset.cartKey;

    const remove = event.target.closest("[data-sc-cart-remove]");
    const quantityButton = event.target.closest("[data-sc-cart-qty]");
    if (!remove && !quantityButton) return;

    event.preventDefault();
    const quantity = remove ? 0 : Number(quantityButton.dataset.scCartQty);
    try {
      await changeLine(key, Math.max(0, quantity));
      const cart = await syncWelcomeGifts(await fetchCart());
      renderCart(cart);
    } catch (error) {
      renderError(error.message);
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !drawer.hidden) closeDrawer();
  });

  document.addEventListener("click", async (event) => {
    const trigger = event.target.closest('[data-sc-open-cart], a[href="/cart"], a[href$="/cart"]');
    if (!trigger || trigger.closest('form[action*="/cart/add"]')) return;
    event.preventDefault();
    try {
      renderCart(await syncWelcomeGifts(await fetchCart()));
    } catch (error) {
      renderError(error.message);
    }
  });

  updateShipping();
  window.setInterval(updateShipping, 60000);
})();
